import { type ApiResponse } from "apisauce"

import { type SuggestionAddress } from "../../components/AutoComplete/AddressAutoComplete"
import { type ZipMatch } from "../../components/AutoComplete/zip-lookup"
import { request } from "../api"

const BASE_URL = "/crm/leads"

const PATHS = {
  // Autocomplete
  autocompleteAddress: `${BASE_URL}/autocomplete-address/`,
  autocompleteCity: `${BASE_URL}/autocomplete-city/`,
  autocompleteStreet: `${BASE_URL}/autocomplete-street/`,
  autocompleteZip: `${BASE_URL}/autocomplete-zip/`
}

// Autocomplete
export const autocompleteAddress = (
  params: Record<string, unknown>
): Promise<ApiResponse<{ suggestions: SuggestionAddress[] }>> =>
  request.api.get(PATHS.autocompleteAddress, params)

export const autocompleteCity = (params: Record<string, unknown>) =>
  request.api.get(PATHS.autocompleteCity, params)

export const autocompleteStreet = (params: Record<string, unknown>) =>
  request.api.get(PATHS.autocompleteStreet, params)

export const autocompleteZip = (
  params: Record<string, unknown>
): Promise<ApiResponse<{ suggestions: ZipMatch[] }>> =>
  request.api.get(PATHS.autocompleteZip, params)
